import { render, staticRenderFns } from "./gain_order_type.vue?vue&type=template&id=236939c1&scoped=true"
import script from "./gain_order_type.vue?vue&type=script&lang=js"
export * from "./gain_order_type.vue?vue&type=script&lang=js"
import style0 from "./gain_order_type.vue?vue&type=style&index=0&id=236939c1&prod&lang=scss&scoped=true"
import style1 from "./gain_order_type.vue?vue&type=style&index=1&id=236939c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236939c1",
  null
  
)

export default component.exports